import { useEffect } from 'react';

export default function useScrollTop() {
    useEffect(
        () => {
            // Set up
            window.scrollTo(0, 0)
            // Clean up
            return () => { };
        },
        []
    );
}